import "../../styles/screens/services.scss";
import coinsIcon from "../../assets/images/Icons/coinsIcon.png";
import coinImg from "../../assets/images/Images/coinImg.png";
import AOS from "aos";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";
import "aos/dist/aos.css";

const ServiceFirst = () => {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const t = language === "sr" ? sr.servicePages.first : de.servicePages.first;
  return (
    <div className="service-first">
      <div className="service-title" data-aos="fade-down">
        <h1 className="title">{t.title}</h1>
        <img className="coins" src={coinsIcon} alt="coins"></img>
      </div>
      <div className="divider"></div>
      <div className="content">
        <ul className="points">
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="100"
          >
            {t.points[0]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="400"
          >
            {t.points[1]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="700"
          >
            {t.points[2]}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1000"
          >
            {t.points[3]}
          </li>
        </ul>
        <div className="image-container">
          <img src={coinImg} alt="Revenue Management" />
        </div>
      </div>
    </div>
  );
};

export default ServiceFirst;
